var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('k-menu',{attrs:{"menu":_vm.menu}}),_c('div',{staticClass:"main-right"},[_c('k-tabs'),_c('div',{staticClass:"main-right-body"},[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }